import { Redirect } from '@reach/router';
import { AppPath } from 'appConstants';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectSignedIn } from 'reducers/auth';

export const Private: React.FC<any> = ({ children }) => {
  const isSignedIn = useSelector(selectSignedIn);

  if (!isSignedIn) return <Redirect noThrow to={AppPath.SIGN_IN} />;

  return <>{children}</>;
};

export default Private;
